import { createStore } from 'redux'
import { pendingEmailReducer } from './reducer'
const store = createStore(pendingEmailReducer)
export default store
